import React from 'react'

class PublicLayout extends React.Component {
	render() {
		return (
	        <section className="body-sign">
				{ this.props.children }
	        </section>
    	)
	}
}

export default PublicLayout;
